import { TextInput } from '@mantine/core';
import styled from 'styled-components';

// Its own card, so it reads as a peer of the BindPanel card below it rather than as
// loose chrome floating above the column.
export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.375rem;
	flex-shrink: 0;
	padding: 0.875rem 0.875rem 0.625rem;
	background-color: #fff;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[2]};
	border-radius: 12px;
`;

// `dark[0]` rather than `gray[6]`, for the same reason BindPanel's eyebrow uses it: v7's
// `gray[6]` is 1.9:1 on white and reads as a smudge at 11px.
export const EyebrowLabel = styled.span`
	display: block;
	font-size: 0.6875rem;
	font-weight: 600;
	letter-spacing: 0.05em;
	text-transform: uppercase;
	color: ${({ theme }) => theme.v3.colors.dark[0]};
`;

// Borderless-until-focused, matching the blank-name input in the panel below: a bold title
// at rest, plainly editable once touched.
export const NameInput = styled(TextInput)`
	min-width: 0;

	input {
		font-size: 1.125rem;
		font-weight: 700;
		border-color: transparent;
		background-color: transparent;
		padding-left: 0;

		&:hover {
			border-color: ${({ theme }) => theme.v3.colors.gray[3]};
		}

		&:focus {
			border-color: ${({ theme }) => theme.v3.colors.blue[5]};
			background-color: #fff;
			padding-left: 0.5rem;
		}
	}
`;
